import { render, staticRenderFns } from "./RegisterPromoWidget.vue?vue&type=template&id=400119f2&scoped=true"
import script from "./RegisterPromoWidget.vue?vue&type=script&lang=js"
export * from "./RegisterPromoWidget.vue?vue&type=script&lang=js"
import style0 from "./RegisterPromoWidget.vue?vue&type=style&index=0&id=400119f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400119f2",
  null
  
)

export default component.exports